import React from "react";
import { dot_selector } from "../../common/dot_selector";
import api from "../../lib/api";
import classnames from "classnames";
import { modal } from "../../common/modal";
import { Link } from "../../lib/Link";

/* eslint-disable max-params */
export const gallery = (type, asset, activeImageIndex, onSelectActiveImage, onSelectNextActiveImage) => {
  const vrs = asset.vrs || []; // ここにデフォルトのURLを記述する
  const imageId = asset.images && asset.images[activeImageIndex || 0];
  const imageUrl = api.assetImageUrl(asset.assetId, imageId, activeImageIndex || 0);
  const background = imageId && `url(${imageUrl})`;
  return (
    <div className="gallery">
      <div className="left">
        <div className="mainimg">
          <span className="arrow">
            <img
              className="ar"
              onClick={() => onSelectNextActiveImage(false)}
              src="resource/img/s_arrow_left.png"
            />
          </span>
          <div
            className="pc img link"
            onClick={() => onSelectNextActiveImage(true)}
            style={{ backgroundImage: background }}
          />
          <span className="arrow">
            <img
              className="ar"
              onClick={() => onSelectNextActiveImage(true)}
              src="resource/img/s_arrow_right.png"
            />
          </span>
        </div>
        {/*asset.smartKeyChangeFlg === true ?
          <Link to={"/smartkey/change?assetId="+asset.assetId} className="banner"><img className="link" src="resource/img/smartkey_lp_banner.png" /></Link> :
          asset.smartKeyFlg && <Link to="/app/" className="banner"><img className="link" src="resource/img/smartkey_banner.png" /></Link>
        */
          asset.isRegistFelicaObject == 1 && <Link to="/app/" className="banner"><img className="link" src="resource/img/felica_banner20201001.png" /></Link>
        }
      </div>
      <div className="title">ギャラリー</div>
      <div className="collection type inside degrees">
        {asset.images &&
          asset.images.map((imageId, index) => (
            <img
              className={
                "link " + classnames({ active: index === activeImageIndex })
              }
              key={index}
              onClick={() => onSelectActiveImage(index)}
              src={api.assetImageUrl(asset.assetId, imageId, index)}
              alt={asset.name + "_ギャラリー_" + (index + 1)}
            />
          ))}
        {vrs &&
          vrs.map((item, index) => (
            <img
              className="degrees link"
              key={index}
              onClick={() =>
                modal.openModal("modal_threed_view", {
                  iframeUrl: item.iframeSrc,
                })
              }
              // indexは0から始まるので、アイコン画像1から表示するために+1する
              src={"resource/img/360_degrees_" + item.vrType + ".png"}
              alt={asset.name + "_ギャラリー_" + (index + 1)}
            />
          ))}
      </div>
      <div className="sp">{dot_selector(3)}</div>
      <div>写真はイメージです。実際の仕様と異なる場合があります。</div>
    </div>
  );
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./pages/detail/gallery.jsx